"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_jsonschema_form_1 = require("react-jsonschema-form");
var ButtonSubmit_1 = require("../buttonSubmit/ButtonSubmit");
var CustomComponentsMapper_1 = require("../CustomComponentsMapper");
var enquiryFormStyles_1 = require("./enquiryFormStyles");
var useEnquiryFormSubmit_1 = require("../../hooks/useEnquiryFormSubmit");
var useEnquiryFormValidate_1 = require("../../hooks/useEnquiryFormValidate");
var BleedContainer_1 = require("../../../common/components/presentation/Misc/BleedContainer");
var useCustomErrorMessagesMapper_1 = require("../../hooks/useCustomErrorMessagesMapper");
var errorMessageHoc_1 = require("../../../common/components/presentation/Error/errorMessageHoc");
var ObjectFieldTemplate_1 = require("../objectFieldTemplate/ObjectFieldTemplate");
var MinimalLoader_1 = require("../../../common/components/presentation/MinimalLoader/MinimalLoader");
var useEnquiryFormData_1 = require("../../hooks/useEnquiryFormData");
var react_intl_1 = require("react-intl");
var useRecaptcha_1 = require("../../../common/hooks/useRecaptcha");
var EnquiryForm = function (_a) {
    var componentHandleError = _a.componentHandleError, journeyType = _a.journeyType;
    var intl = react_intl_1.useIntl();
    var styles = enquiryFormStyles_1.default();
    var _b = useEnquiryFormData_1.useEnquireFormData(componentHandleError, journeyType), formData = _b.formData, handleFormChange = _b.handleFormChange, formSchema = _b.formSchema, uiSchema = _b.uiSchema, requiredFields = _b.requiredFields;
    var _c = useEnquiryFormValidate_1.default(requiredFields, intl), hasErrors = _c.hasErrors, asyncErrors = _c.asyncErrors, handleValidationErrors = _c.handleValidationErrors, handleAsyncValidationErrors = _c.handleAsyncValidationErrors, resetAsyncErrors = _c.resetAsyncErrors;
    var _d = useEnquiryFormSubmit_1.default(handleAsyncValidationErrors, journeyType), onSubmit = _d.onSubmit, isSubmitting = _d.isSubmitting, error = _d.error;
    var customErrorMessageMapper = useCustomErrorMessagesMapper_1.useCustomErrorMessagesMapper(intl);
    var _e = react_1.useState([]), availableDealers = _e[0], setAvailableDealers = _e[1];
    var customWidgets = react_1.useMemo(function () { return CustomComponentsMapper_1.default(); }, [journeyType]);
    var onChange = react_1.useCallback(function (data) {
        if (asyncErrors !== null) {
            resetAsyncErrors();
            data.errors = null;
        }
        handleFormChange(data.formData);
        handleValidationErrors(data);
    }, [asyncErrors, requiredFields]);
    react_1.useEffect(function () {
        if (formData) {
            handleValidationErrors({ formData: formData });
        }
    }, []);
    useRecaptcha_1.default();
    react_1.useEffect(function () { return componentHandleError(error); }, [error]);
    if (!formData || !formSchema || !uiSchema) {
        return <MinimalLoader_1.default />;
    }
    return (<BleedContainer_1.default>
      <core_1.Grid container={true} data-test="container:checkout:enquiryForm" className={styles.formWrapper}>
        <react_jsonschema_form_1.default formContext={{ availableDealers: availableDealers, setAvailableDealers: setAvailableDealers }} schema={formSchema} uiSchema={uiSchema} formData={formData} onSubmit={onSubmit} onChange={onChange} submitOnEnter={true} liveValidate={true} showErrorList={false} transformErrors={customErrorMessageMapper} widgets={customWidgets} ObjectFieldTemplate={ObjectFieldTemplate_1.default} extraErrors={asyncErrors}>
          <ButtonSubmit_1.default disabled={isSubmitting || hasErrors || !!asyncErrors} journeyType={journeyType}/>
        </react_jsonschema_form_1.default>
      </core_1.Grid>
    </BleedContainer_1.default>);
};
exports.default = errorMessageHoc_1.default(EnquiryForm);
